<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" @click="$emit('click')">
		<g fill="none" fill-rule="evenodd">
			<g>
				<g transform="translate(-1208.000000, -108.000000) translate(1209.000000, 109.000000)">
					<circle cx="10" cy="10" r="10" stroke="#487FFF"/>
					<path fill="#487FFF" fill-rule="nonzero" d="M7.273 8.115c0-.403.13-.812.388-1.225.259-.414.636-.757 1.133-1.028.496-.272 1.075-.407 1.737-.407.615 0 1.158.113 1.629.34.47.227.835.536 1.091.926.257.39.385.814.385 1.273 0 .36-.073.676-.22.948-.146.271-.32.506-.521.703-.202.197-.563.53-1.085.996-.144.131-.26.247-.347.347-.087.1-.151.19-.194.273-.042.083-.075.166-.099.249-.023.082-.058.228-.105.435-.08.442-.333.662-.757.662-.22 0-.406-.072-.557-.216-.15-.144-.226-.359-.226-.643 0-.356.056-.665.166-.926.11-.26.257-.49.439-.687.182-.197.428-.432.738-.703.272-.238.468-.417.589-.538.12-.12.223-.256.305-.404.083-.148.124-.31.124-.484 0-.339-.126-.625-.378-.859-.253-.233-.578-.35-.977-.35-.467 0-.81.118-1.031.353-.22.236-.407.583-.56 1.04-.144.48-.418.72-.82.72-.238 0-.439-.084-.602-.251-.164-.168-.245-.35-.245-.544zm3.105 6.974c-.259 0-.485-.084-.678-.251-.193-.168-.29-.402-.29-.703 0-.268.094-.493.28-.675.188-.182.417-.274.688-.274.267 0 .492.092.675.274.182.182.273.407.273.675 0 .297-.095.53-.286.7-.19.17-.412.254-.662.254z"/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'info-icon',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/info-icon.vue